import React, { FC } from 'react'

interface Props {
	cellTags: string[]
}

export const Cell: FC<Props> = ({ children }) => {
	return <>{children}</>
}
